import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow } from "vue"

const _hoisted_1 = { id: "tacho-file-analysis" }
const _hoisted_2 = {
  key: 1,
  class: "tfa-card tfa-drivers"
}
const _hoisted_3 = { class: "tfa-drivers-head" }
const _hoisted_4 = { class: "tfa-eyebrow" }
const _hoisted_5 = { class: "tfa-page-title" }
const _hoisted_6 = { class: "tfa-page-sub" }
const _hoisted_7 = { class: "tfa-drivers-controls" }
const _hoisted_8 = { class: "tfa-stats" }
const _hoisted_9 = {
  key: 0,
  class: "tfa-upload"
}
const _hoisted_10 = { class: "tfa-upload-head" }
const _hoisted_11 = { class: "tfa-upload-options" }
const _hoisted_12 = {
  key: 0,
  class: "tfa-loading-box"
}
const _hoisted_13 = { class: "tfa-dropzone-title" }
const _hoisted_14 = { class: "tfa-dropzone-sub" }
const _hoisted_15 = { class: "tfa-dropzone-btn" }
const _hoisted_16 = { class: "tfa-coverage" }
const _hoisted_17 = { class: "tfa-coverage-label" }
const _hoisted_18 = { class: "tfa-coverage-controls" }
const _hoisted_19 = { class: "tfa-quick" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 1,
  class: "tfa-error"
}
const _hoisted_23 = { class: "tfa-grid-driver" }
const _hoisted_24 = { class: "tfa-grid-avatar" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mono" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "tfa-grid-empty"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "tfa-grid-empty"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "tfa-grid-empty"
}
const _hoisted_34 = { class: "tfa-grid-actions" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 2,
  class: "tfa-card tfa-detail-state"
}
const _hoisted_38 = {
  key: 3,
  class: "tfa-card tfa-detail-state tfa-detail-state--error"
}
const _hoisted_39 = { class: "tfa-error" }
const _hoisted_40 = { class: "tfa-options" }
const _hoisted_41 = {
  key: 0,
  class: "tfa-file-chip"
}
const _hoisted_42 = { class: "tfa-driver" }
const _hoisted_43 = { class: "tfa-avatar" }
const _hoisted_44 = { class: "tfa-driver-main" }
const _hoisted_45 = { class: "tfa-driver-name" }
const _hoisted_46 = { class: "tfa-driver-meta" }
const _hoisted_47 = { class: "tfa-tabs" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "tfa-badge"
}
const _hoisted_50 = {
  key: 0,
  class: "tfa-card",
  ref: "activityCard"
}
const _hoisted_51 = { class: "tfa-card-head" }
const _hoisted_52 = { class: "tfa-card-head-left" }
const _hoisted_53 = { class: "tfa-card-title" }
const _hoisted_54 = { class: "tfa-view-toggle" }
const _hoisted_55 = { class: "tfa-legend" }
const _hoisted_56 = { class: "tfa-place-legend tfa-place-legend--start" }
const _hoisted_57 = { class: "tfa-place-legend tfa-place-legend--end" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 0,
  class: "tfa-empty"
}
const _hoisted_60 = { class: "tfa-range-filter" }
const _hoisted_61 = { class: "tfa-quick" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { class: "tfa-range-custom" }
const _hoisted_64 = ["value", "min", "max"]
const _hoisted_65 = ["value", "min", "max"]
const _hoisted_66 = { class: "tfa-range-count" }
const _hoisted_67 = {
  key: 0,
  class: "tfa-times"
}
const _hoisted_68 = { class: "tfa-times-head" }
const _hoisted_69 = { class: "tfa-times-tile" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "tfa-times-tile" }
const _hoisted_72 = { class: "tfa-times-tile" }
const _hoisted_73 = { class: "tfa-times-tile" }
const _hoisted_74 = { class: "tfa-times-tile" }
const _hoisted_75 = { class: "tfa-times-tile" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { class: "tfa-times-tile" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  key: 1,
  class: "tfa-empty"
}
const _hoisted_80 = {
  key: 2,
  class: "tfa-day-workspace"
}
const _hoisted_81 = { class: "tfa-day-rail" }
const _hoisted_82 = { class: "tfa-rail-summary" }
const _hoisted_83 = { class: "tfa-rail-summary-title" }
const _hoisted_84 = { class: "tfa-rail-summary-grid" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "tfa-rail-date" }
const _hoisted_87 = { class: "tfa-rail-drive" }
const _hoisted_88 = { class: "tfa-mini-track" }
const _hoisted_89 = { class: "tfa-activity-tooltip" }
const _hoisted_90 = { class: "tfa-activity-tooltip-head" }
const _hoisted_91 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_92 = { class: "tfa-activity-tooltip-range" }
const _hoisted_93 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_94 = { class: "tfa-activity-tooltip-day" }
const _hoisted_95 = { class: "tfa-activity-tooltip" }
const _hoisted_96 = { class: "tfa-activity-tooltip-head" }
const _hoisted_97 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_98 = { class: "tfa-activity-tooltip-range" }
const _hoisted_99 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_100 = { class: "tfa-activity-tooltip-day" }
const _hoisted_101 = ["title"]
const _hoisted_102 = {
  key: 0,
  class: "tfa-day-pane"
}
const _hoisted_103 = { class: "tfa-day-pane-head" }
const _hoisted_104 = ["disabled", "title"]
const _hoisted_105 = { class: "tfa-day-pane-title" }
const _hoisted_106 = ["disabled", "title"]
const _hoisted_107 = { class: "tfa-chipstats" }
const _hoisted_108 = {
  key: 0,
  class: "tfa-chipstat"
}
const _hoisted_109 = { class: "tfa-day-section" }
const _hoisted_110 = { class: "tfa-chart" }
const _hoisted_111 = { class: "tfa-gutter" }
const _hoisted_112 = { class: "tfa-track" }
const _hoisted_113 = {
  key: 0,
  class: "tfa-bar-label"
}
const _hoisted_114 = { class: "tfa-activity-tooltip" }
const _hoisted_115 = { class: "tfa-activity-tooltip-head" }
const _hoisted_116 = {
  key: 0,
  class: "tfa-activity-tooltip-rest"
}
const _hoisted_117 = { class: "tfa-activity-tooltip-range" }
const _hoisted_118 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_119 = { class: "tfa-activity-tooltip-day" }
const _hoisted_120 = { class: "tfa-activity-tooltip" }
const _hoisted_121 = { class: "tfa-activity-tooltip-head" }
const _hoisted_122 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_123 = { class: "tfa-activity-tooltip-range" }
const _hoisted_124 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_125 = { class: "tfa-activity-tooltip-day" }
const _hoisted_126 = { class: "tfa-activity-tooltip" }
const _hoisted_127 = { class: "tfa-activity-tooltip-head" }
const _hoisted_128 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_129 = { class: "tfa-activity-tooltip-range" }
const _hoisted_130 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_131 = { class: "tfa-activity-tooltip-day" }
const _hoisted_132 = ["title"]
const _hoisted_133 = { class: "tfa-place-marker-label" }
const _hoisted_134 = { class: "tfa-place-tooltip" }
const _hoisted_135 = { class: "tfa-place-tooltip-head" }
const _hoisted_136 = { class: "tfa-place-tooltip-time" }
const _hoisted_137 = { class: "tfa-place-tooltip-location" }
const _hoisted_138 = { class: "tfa-place-tooltip-odo" }
const _hoisted_139 = { class: "tfa-place-tooltip-day" }
const _hoisted_140 = { class: "tfa-axis" }
const _hoisted_141 = {
  key: 0,
  class: "tfa-place-chips"
}
const _hoisted_142 = ["title"]
const _hoisted_143 = {
  key: 1,
  class: "tfa-brush"
}
const _hoisted_144 = { class: "tfa-day-section" }
const _hoisted_145 = { class: "tfa-detail tfa-detail--day-pane" }
const _hoisted_146 = { class: "tfa-detail-count" }
const _hoisted_147 = {
  key: 0,
  class: "tfa-ivs"
}
const _hoisted_148 = { class: "tfa-iv-time mono" }
const _hoisted_149 = { class: "tfa-iv-name" }
const _hoisted_150 = {
  key: 0,
  class: "tfa-iv-tags"
}
const _hoisted_151 = {
  key: 0,
  class: "tfa-place-tag"
}
const _hoisted_152 = {
  key: 1,
  class: "tfa-ferry-tag"
}
const _hoisted_153 = { class: "tfa-iv-dur mono" }
const _hoisted_154 = {
  key: 0,
  class: "tfa-day-section"
}
const _hoisted_155 = { class: "tfa-day-rows" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = {
  key: 1,
  class: "tfa-day-section"
}
const _hoisted_158 = { class: "tfa-day-rows" }
const _hoisted_159 = {
  key: 2,
  class: "tfa-day-section"
}
const _hoisted_160 = { class: "tfa-day-rows" }
const _hoisted_161 = {
  key: 1,
  class: "tfa-day-pane"
}
const _hoisted_162 = { class: "tfa-empty tfa-empty--pad" }
const _hoisted_163 = { class: "tfa-week-head" }
const _hoisted_164 = { class: "tfa-week-title" }
const _hoisted_165 = { class: "tfa-week-sums" }
const _hoisted_166 = { class: "tfa-week-sum drive" }
const _hoisted_167 = { class: "tfa-week-sum work" }
const _hoisted_168 = { class: "tfa-week-sum dw" }
const _hoisted_169 = { class: "tfa-chart tfa-chart--week" }
const _hoisted_170 = { class: "tfa-gutter" }
const _hoisted_171 = { class: "tfa-track" }
const _hoisted_172 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_173 = {
  key: 0,
  class: "tfa-day-tooltip"
}
const _hoisted_174 = { class: "tfa-day-tooltip-head" }
const _hoisted_175 = { class: "tfa-day-tooltip-dow" }
const _hoisted_176 = { class: "tfa-day-tooltip-total drive" }
const _hoisted_177 = { class: "tfa-day-tooltip-total work" }
const _hoisted_178 = { class: "tfa-day-tooltip-total" }
const _hoisted_179 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_180 = {
  key: 0,
  class: "tfa-bar-label"
}
const _hoisted_181 = { class: "tfa-activity-tooltip" }
const _hoisted_182 = { class: "tfa-activity-tooltip-head" }
const _hoisted_183 = {
  key: 0,
  class: "tfa-activity-tooltip-rest"
}
const _hoisted_184 = { class: "tfa-activity-tooltip-range" }
const _hoisted_185 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_186 = { class: "tfa-activity-tooltip-day" }
const _hoisted_187 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_188 = { class: "tfa-activity-tooltip" }
const _hoisted_189 = { class: "tfa-activity-tooltip-head" }
const _hoisted_190 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_191 = { class: "tfa-activity-tooltip-range" }
const _hoisted_192 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_193 = { class: "tfa-activity-tooltip-day" }
const _hoisted_194 = ["onMouseenter", "onMouseleave", "onClick"]
const _hoisted_195 = { class: "tfa-activity-tooltip" }
const _hoisted_196 = { class: "tfa-activity-tooltip-head" }
const _hoisted_197 = { class: "tfa-activity-tooltip-rest" }
const _hoisted_198 = { class: "tfa-activity-tooltip-range" }
const _hoisted_199 = { class: "tfa-activity-tooltip-duration" }
const _hoisted_200 = { class: "tfa-activity-tooltip-day" }
const _hoisted_201 = ["title", "onMouseenter", "onMouseleave"]
const _hoisted_202 = { class: "tfa-place-marker-label" }
const _hoisted_203 = { class: "tfa-place-tooltip" }
const _hoisted_204 = { class: "tfa-place-tooltip-head" }
const _hoisted_205 = { class: "tfa-place-tooltip-time" }
const _hoisted_206 = { class: "tfa-place-tooltip-location" }
const _hoisted_207 = { class: "tfa-place-tooltip-odo" }
const _hoisted_208 = { class: "tfa-place-tooltip-day" }
const _hoisted_209 = { class: "tfa-week-axis" }
const _hoisted_210 = ["onClick"]
const _hoisted_211 = {
  key: 1,
  class: "tfa-card tfa-card--table"
}
const _hoisted_212 = { class: "tfa-table-head" }
const _hoisted_213 = { class: "tfa-card-title" }
const _hoisted_214 = { class: "tfa-table-meta" }
const _hoisted_215 = {
  key: 0,
  class: "tfa-empty tfa-empty--pad"
}
const _hoisted_216 = {
  key: 1,
  class: "tfa-veh-list"
}
const _hoisted_217 = { class: "tfa-veh-head" }
const _hoisted_218 = { class: "tfa-plate" }
const _hoisted_219 = { class: "tfa-plate-cc" }
const _hoisted_220 = { class: "tfa-plate-num" }
const _hoisted_221 = { class: "tfa-veh-range" }
const _hoisted_222 = {
  key: 0,
  class: "tfa-veh-open"
}
const _hoisted_223 = { class: "tfa-spark-row" }
const _hoisted_224 = { class: "tfa-spark-cap" }
const _hoisted_225 = { class: "tfa-spark" }
const _hoisted_226 = { class: "tfa-spark-tooltip" }
const _hoisted_227 = { class: "tfa-spark-tooltip-head" }
const _hoisted_228 = { class: "tfa-spark-tooltip-date" }
const _hoisted_229 = { class: "tfa-spark-tooltip-km" }
const _hoisted_230 = { class: "tfa-veh-foot" }
const _hoisted_231 = { class: "mono" }
const _hoisted_232 = { class: "tfa-veh-total" }
const _hoisted_233 = {
  key: 2,
  class: "tfa-card tfa-card--table"
}
const _hoisted_234 = { class: "tfa-table-head" }
const _hoisted_235 = { class: "tfa-card-title" }
const _hoisted_236 = { class: "tfa-table-sub" }
const _hoisted_237 = {
  key: 0,
  class: "tfa-empty tfa-empty--pad"
}
const _hoisted_238 = { class: "tfa-grid tfa-grid--places tfa-grid-head" }
const _hoisted_239 = { class: "ar" }
const _hoisted_240 = { class: "mono tfa-cell-sub2" }
const _hoisted_241 = { class: "tfa-cell-place" }
const _hoisted_242 = ["href"]
const _hoisted_243 = { key: 1 }
const _hoisted_244 = { class: "ar mono" }
const _hoisted_245 = {
  key: 3,
  class: "tfa-card tfa-card--table"
}
const _hoisted_246 = { class: "tfa-table-head" }
const _hoisted_247 = { class: "tfa-card-title" }
const _hoisted_248 = { class: "tfa-table-meta" }
const _hoisted_249 = {
  key: 0,
  class: "tfa-empty tfa-empty--pad"
}
const _hoisted_250 = { key: 1 }
const _hoisted_251 = { class: "mono tfa-cell-sub2" }
const _hoisted_252 = { class: "tfa-cell-evt" }
const _hoisted_253 = { class: "fw6" }
const _hoisted_254 = { class: "tfa-cell-sub" }
const _hoisted_255 = { class: "mono tfa-cell-sub2" }
const _hoisted_256 = {
  key: 4,
  class: "tfa-card tfa-card--table"
}
const _hoisted_257 = { class: "tfa-table-head" }
const _hoisted_258 = { class: "tfa-card-title" }
const _hoisted_259 = { class: "tfa-table-sub" }
const _hoisted_260 = { class: "tfa-table-meta" }
const _hoisted_261 = {
  key: 0,
  class: "tfa-empty tfa-empty--pad"
}
const _hoisted_262 = { key: 1 }
const _hoisted_263 = { class: "mono tfa-cell-sub2" }
const _hoisted_264 = { class: "tfa-cell-evt" }
const _hoisted_265 = { class: "fw6" }
const _hoisted_266 = { class: "tfa-cell-sub" }
const _hoisted_267 = { class: "mono tfa-cell-sub2" }
const _hoisted_268 = {
  key: 5,
  class: "tfa-card"
}
const _hoisted_269 = { class: "tfa-card-title tfa-mb" }
const _hoisted_270 = {
  key: 0,
  class: "tfa-empty"
}
const _hoisted_271 = {
  key: 1,
  class: "tfa-id-grid"
}
const _hoisted_272 = { class: "tfa-id-label" }
const _hoisted_273 = { key: 0 }
const _hoisted_274 = { class: "tfa-id-label" }
const _hoisted_275 = { class: "tfa-id-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_TachoRemoteFilesModal = _resolveComponent("TachoRemoteFilesModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.detailOnly)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          ref: "fileInput",
          type: "file",
          class: "tfa-file-input",
          accept: ".ddd,.DDD",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
        }, null, 544))
      : _createCommentVNode("", true),
    (!_ctx.detailOnly)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.eyebrow')), 1),
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.title')), 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.sub')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "tfa-btn tfa-btn--primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleUpload && _ctx.toggleUpload(...args)))
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "bi bi-cloud-arrow-up" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.uploadButton')), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "tfa-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshDrivers && _ctx.refreshDrivers(...args)))
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.refresh')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.stats.active), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.stats.active')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.stats.saved), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.stats.saved')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.stats.missing), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.stats.missing')), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.stats.days), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.stats.days')), 1)
            ])
          ]),
          (_ctx.uploadOpen)
            ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.importTitle')), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.importSub')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "tfa-btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeUpload && _ctx.closeUpload(...args)))
                    }, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.close')), 1)
                  ])
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _cache[25] || (_cache[25] = _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.processing')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["tfa-dropzone", { 'tfa-dropzone--active': _ctx.dragActive }]),
                      onDragover: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                      onDragleave: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                      onDrop: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["prevent"])),
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.triggerFilePicker && _ctx.triggerFilePicker(...args)))
                    }, [
                      _cache[27] || (_cache[27] = _createElementVNode("i", { class: "bi bi-cloud-arrow-up" }, null, -1)),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('components.tachoAnalysis.dropTitle')), 1),
                      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('components.tachoAnalysis.dropSub')), 1),
                      _createElementVNode("span", _hoisted_15, [
                        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "bi bi-folder2-open" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.chooseFile')), 1)
                      ])
                    ], 34))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.coverage')), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.coverageSub')), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (s) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: s.key,
                    type: "button",
                    class: _normalizeClass({ active: _ctx.statusFilter === s.key }),
                    onClick: ($event: any) => (_ctx.statusFilter = s.key)
                  }, _toDisplayString(s.label), 11, _hoisted_20))
                }), 128))
              ]),
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.from')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.coverageFrom) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _ctx.coverageFrom]
              ]),
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.to')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.coverageTo) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _ctx.coverageTo]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "tfa-btn",
                disabled: !_ctx.coverageFrom && !_ctx.coverageTo,
                onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.coverageFrom = ''; _ctx.coverageTo = ''})
              }, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.clear')), 9, _hoisted_21)
            ])
          ]),
          (_ctx.driversError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.driversError), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_DxDataGrid, {
            ref: "driversGrid",
            class: "tfa-drivers-grid",
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.driversStore,
            "hover-state-enabled": true,
            "no-data-text": _ctx.$t('components.tachoAnalysis.drivers.noDrivers'),
            "remote-operations": { paging: true, sorting: true, filtering: true },
            "row-alternation-enabled": true,
            "show-borders": false,
            "show-column-lines": false
          }, {
            "driver-cell": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.driverInitials(data.data)), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.driverFullName(data.data) || _ctx.$t('components.tachoAnalysis.drivers.unknown')), 1),
                  _createElementVNode("small", null, "ID " + _toDisplayString(data.data.driver_id), 1)
                ])
              ])
            ]),
            "card-cell": _withCtx(({ data }) => [
              (data.data.card_number)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("strong", _hoisted_26, _toDisplayString(data.data.card_number), 1),
                    (data.data.card_expiry_date)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.validTo')) + " " + _toDisplayString(_ctx.fmtDay(data.data.card_expiry_date)), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.noCard')), 1))
            ]),
            "range-cell": _withCtx(({ data }) => [
              (data.data.activity_from)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.fmtDay(data.data.activity_from)) + " – " + _toDisplayString(_ctx.fmtDay(data.data.activity_to)), 1),
                    _createElementVNode("small", null, _toDisplayString(data.data.days_count) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.savedDays')), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.noData')), 1))
            ]),
            "import-cell": _withCtx(({ data }) => [
              (data.data.last_uploaded_at)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.fmtDateTime(data.data.last_uploaded_at)), 1),
                    (data.data.last_filename)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(data.data.last_filename), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.noImport')), 1))
            ]),
            "state-cell": _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["tfa-pill", data.data.has_saved_data ? 'tfa-pill--ready' : 'tfa-pill--missing'])
              }, _toDisplayString(data.data.has_saved_data ? _ctx.$t('components.tachoAnalysis.drivers.stateReady') : _ctx.$t('components.tachoAnalysis.drivers.stateMissing')), 3)
            ]),
            "actions-cell": _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_34, [
                (data.data.has_saved_data)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "tfa-btn tfa-btn--primary tfa-btn--sm",
                      onClick: ($event: any) => (_ctx.openDriver(data.data))
                    }, _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.openData')), 9, _hoisted_35))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "tfa-btn tfa-btn--sm",
                  onClick: ($event: any) => (_ctx.openRemoteFiles(data.data))
                }, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.button')), 9, _hoisted_36)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxPaging, { "page-size": 25 }),
              _createVNode(_component_DxPager, {
                "show-info": true,
                "show-navigation-buttons": true,
                visible: true,
                "info-text": _ctx.$t('components.devexpress.pagerPage')
            + '{0}' + _ctx.$t('components.devexpress.pagerOf')
            + '{1}'
              }, null, 8, ["info-text"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.driver'),
                "calculate-filter-expression": _ctx.driverFilterExpression,
                "min-width": 220,
                "data-field": "last_name",
                "cell-template": "driver-cell"
              }, null, 8, ["caption", "calculate-filter-expression"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.card'),
                "min-width": 180,
                "data-field": "card_number",
                "cell-template": "card-cell"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": false,
                "allow-search": false,
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.range'),
                "min-width": 210,
                "data-field": "activity_from",
                "cell-template": "range-cell"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": false,
                "allow-search": false,
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.lastImport'),
                "min-width": 170,
                "data-field": "last_uploaded_at",
                "sort-order": "desc",
                "cell-template": "import-cell"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": false,
                "allow-search": false,
                "allow-sorting": false,
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.state'),
                "css-class": "tfa-grid-state-cell",
                width: 140,
                "cell-template": "state-cell"
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                "allow-filtering": false,
                "allow-search": false,
                "allow-sorting": false,
                caption: _ctx.$t('components.tachoAnalysis.drivers.grid.actions'),
                width: 220,
                "cell-template": "actions-cell"
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source", "no-data-text"]),
          _createVNode(_component_TachoRemoteFilesModal, {
            ref: "remoteFilesModal",
            onImported: _ctx.refreshDrivers
          }, null, 8, ["onImported"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.detailOnly && _ctx.loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_37, [
          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.processing')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.detailOnly && !_ctx.loading && _ctx.driversError)
      ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.driversError), 1),
          _createElementVNode("button", {
            type: "button",
            class: "tfa-btn",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeWorkspace && _ctx.closeWorkspace(...args)))
          }, [
            _cache[29] || (_cache[29] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.backToList')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.result)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_40, [
            (_ctx.source === 'stored')
              ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                  _cache[30] || (_cache[30] = _createElementVNode("i", { class: "bi bi-database-check" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.storedChip')), 1),
                  (_ctx.storedMeta?.last_uploaded_at)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(_ctx.$t('components.tachoAnalysis.drivers.grid.lastImport')) + " " + _toDisplayString(_ctx.fmtDateTime(_ctx.storedMeta.last_uploaded_at)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "tfa-options-spacer" }, null, -1)),
            _createElementVNode("button", {
              type: "button",
              class: "tfa-btn",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeWorkspace && _ctx.closeWorkspace(...args)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["bi", _ctx.detailOnly ? 'bi-arrow-left' : 'bi-x-lg'])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.detailOnly ? _ctx.$t('components.tachoAnalysis.drivers.backToList') : _ctx.$t('components.tachoAnalysis.drivers.close')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.holderInitials), 1),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.display(_ctx.summary.holder_name)), 1),
              _createElementVNode("div", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.driverMetaItems, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: i,
                    class: _normalizeClass(["tfa-driver-meta-chip", { mono: item.mono }])
                  }, [
                    (item.icon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["bi", item.icon])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.key,
                class: _normalizeClass({ active: _ctx.activeTab === tab.key }),
                onClick: ($event: any) => (_ctx.activeTab = tab.key)
              }, [
                _createTextVNode(_toDisplayString(tab.label) + " ", 1),
                (tab.badge)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(tab.badge), 1))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_48))
            }), 128))
          ]),
          (_ctx.activeTab === 'activity')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('components.tachoAnalysis.tabs.activity')), 1),
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ active: _ctx.viewMode === 'week' }),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setViewMode('week')))
                      }, _toDisplayString(_ctx.$t('components.tachoAnalysis.viewWeek')), 3),
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ active: _ctx.viewMode === 'day' }),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setViewMode('day')))
                      }, _toDisplayString(_ctx.$t('components.tachoAnalysis.viewDay')), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("span", null, [
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "sq drive" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.activities.drive')), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "sq rest" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.activities.rest')), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _cache[34] || (_cache[34] = _createElementVNode("span", { class: "sq work" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.activities.work')), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "sq avail" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.activities.available')), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('components.tachoAnalysis.placeShort.start')), 1),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.legendPlaceStart')), 1)
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t('components.tachoAnalysis.placeShort.end')), 1),
                      _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.legendPlaceEnd')), 1)
                    ]),
                    (_ctx.hasFerryConditions)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "tfa-ferry-legend" }, "P", -1)),
                          _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.ferry.legend')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!_ctx.days.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(_ctx.$t('components.tachoAnalysis.noActivity')), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (p) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: p.key,
                              type: "button",
                              class: _normalizeClass({ active: _ctx.rangePreset === p.key }),
                              onClick: ($event: any) => (_ctx.setPreset(p.key))
                            }, _toDisplayString(p.label), 11, _hoisted_62))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.from')), 1),
                          _createElementVNode("input", {
                            type: "date",
                            value: _ctx.effectiveFrom,
                            min: _ctx.minDate,
                            max: _ctx.maxDate,
                            onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onCustomFrom($event)))
                          }, null, 40, _hoisted_64),
                          _createElementVNode("label", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.to')), 1),
                          _createElementVNode("input", {
                            type: "date",
                            value: _ctx.effectiveTo,
                            min: _ctx.minDate,
                            max: _ctx.maxDate,
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onCustomTo($event)))
                          }, null, 40, _hoisted_65)
                        ]),
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('components.tachoAnalysis.daysOf', { shown: _ctx.filteredDays.length, total: _ctx.days.length })), 1)
                      ]),
                      (_ctx.times)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.title')), 1),
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.reference')) + " " + _toDisplayString(_ctx.fmtDateTime(_ctx.times.reference)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.dayDriving')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.times.day.driving_min === null ? '—' : _ctx.hhmm(_ctx.times.day.driving_min)), 1),
                              (_ctx.times.day.rest_end)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.sinceRest')) + " " + _toDisplayString(_ctx.fmtDateTime(_ctx.times.day.rest_end)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.dayWork')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.times.day.work_min === null ? '—' : _ctx.hhmm(_ctx.times.day.work_min)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.continuous')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.hhmm(_ctx.times.continuous.driving_min)), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.remainingBreak')) + " " + _toDisplayString(_ctx.hhmm(_ctx.times.continuous.remaining_min)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.weekDriving')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.hhmm(_ctx.times.weeks.current_driving_min)), 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.twoWeeks')) + " " + _toDisplayString(_ctx.hhmm(_ctx.times.weeks.two_weeks_driving_min)) + " / 90:00", 1)
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.cycle')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.times.cycle.extended_daily_drives) + " / 2 · " + _toDisplayString(_ctx.times.cycle.workdays) + " / 6 · " + _toDisplayString(_ctx.times.cycle.short_daily_rests) + " / 3", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.cycleHint')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.lastDailyRest')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.times.last_daily_rest ? _ctx.hhmm(_ctx.times.last_daily_rest.duration_min) : '—'), 1),
                              (_ctx.times.last_daily_rest)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(_ctx.times.last_daily_rest.label), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.times.lastWeeklyRest')), 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.times.last_weekly_rest ? _ctx.hhmm(_ctx.times.last_weekly_rest.duration_min) : '—'), 1),
                              (_ctx.times.last_weekly_rest)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_78, _toDisplayString(_ctx.times.last_weekly_rest.label), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.filteredDays.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.$t('components.tachoAnalysis.noDaysInRange')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.viewMode === 'day')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createElementVNode("aside", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('components.tachoAnalysis.rangeSummary', { days: _ctx.filteredDays.length })), 1),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("span", null, [
                                    _cache[37] || (_cache[37] = _createElementVNode("span", { class: "tfa-sq tfa-sq--drive" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.hhmm(_ctx.rangeTotals.drive)), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "tfa-sq tfa-sq--work" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.hhmm(_ctx.rangeTotals.work)), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "tfa-sq tfa-sq--avail" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.hhmm(_ctx.rangeTotals.available)), 1)
                                  ]),
                                  _createElementVNode("span", null, [
                                    _cache[40] || (_cache[40] = _createElementVNode("span", { class: "tfa-sq tfa-sq--rest" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.hhmm(_ctx.rangeTotals.rest)), 1)
                                  ])
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDays, (day) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: day.date,
                                  type: "button",
                                  class: _normalizeClass(["tfa-rail-day", { 'is-active': _ctx.selectedDay?.date === day.date }]),
                                  onClick: ($event: any) => (_ctx.selectDay(day.date))
                                }, [
                                  _createElementVNode("span", _hoisted_86, [
                                    _createTextVNode(_toDisplayString(_ctx.fmtDay(day.date)) + " ", 1),
                                    _createElementVNode("small", null, _toDisplayString(_ctx.dowAbbr(_ctx.momentDayNumber(day.date))), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_87, [
                                    _createTextVNode(_toDisplayString(_ctx.hhmm(day.totals?.drive || 0)) + " ", 1),
                                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.activities.drive')), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_88, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayBars(day), (bar, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: i,
                                        class: _normalizeClass(["tfa-mini-seg", ['tfa-mini-seg--' + bar.kind, bar.restKind ? 'tfa-rest--' + bar.restKind : '']]),
                                        style: _normalizeStyle({ left: bar.left, width: bar.width })
                                      }, null, 6))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayFerry(day).ranges, (range, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: 'fr' + i,
                                        class: "tfa-mini-ferry-range",
                                        style: _normalizeStyle({ left: range.left, width: range.width })
                                      }, [
                                        _cache[42] || (_cache[42] = _createElementVNode("span", { class: "tfa-mini-ferry-label" }, "P", -1)),
                                        _createElementVNode("span", _hoisted_89, [
                                          _createElementVNode("span", _hoisted_90, [
                                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                            _createElementVNode("b", null, _toDisplayString(range.tooltip.label), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_91, _toDisplayString(range.tooltip.detail), 1),
                                          _createElementVNode("span", _hoisted_92, _toDisplayString(range.tooltip.range), 1),
                                          _createElementVNode("span", _hoisted_93, _toDisplayString(range.tooltip.duration), 1),
                                          _createElementVNode("span", _hoisted_94, _toDisplayString(range.tooltip.day), 1)
                                        ])
                                      ], 4))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayFerry(day).markers, (marker, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: 'fm' + i,
                                        class: "tfa-mini-ferry-marker",
                                        style: _normalizeStyle({ left: marker.left })
                                      }, [
                                        _cache[44] || (_cache[44] = _createTextVNode(" P ", -1)),
                                        _createElementVNode("span", _hoisted_95, [
                                          _createElementVNode("span", _hoisted_96, [
                                            _cache[43] || (_cache[43] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                            _createElementVNode("b", null, _toDisplayString(marker.tooltip.label), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_97, _toDisplayString(marker.tooltip.detail), 1),
                                          _createElementVNode("span", _hoisted_98, _toDisplayString(marker.tooltip.range), 1),
                                          _createElementVNode("span", _hoisted_99, _toDisplayString(marker.tooltip.duration), 1),
                                          _createElementVNode("span", _hoisted_100, _toDisplayString(marker.tooltip.day), 1)
                                        ])
                                      ], 4))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayPlaces(day), (place, i) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: 'p' + i,
                                        class: _normalizeClass(["tfa-mini-place", 'tfa-mini-place--' + place.kind]),
                                        style: _normalizeStyle({ left: place.left }),
                                        title: place.title
                                      }, _toDisplayString(place.label), 15, _hoisted_101))
                                    }), 128))
                                  ])
                                ], 10, _hoisted_85))
                              }), 128))
                            ]),
                            (_ctx.selectedDay)
                              ? (_openBlock(), _createElementBlock("section", _hoisted_102, [
                                  _createElementVNode("div", _hoisted_103, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "tfa-day-nav",
                                      disabled: !_ctx.canMoveSelectedDay(-1),
                                      title: _ctx.$t('components.tachoAnalysis.prevDay'),
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.moveSelectedDay(-1)))
                                    }, [...(_cache[45] || (_cache[45] = [
                                      _createElementVNode("i", { class: "bi bi-chevron-left" }, null, -1)
                                    ]))], 8, _hoisted_104),
                                    _createElementVNode("div", _hoisted_105, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.dowName(_ctx.selectedDay.date)) + ", " + _toDisplayString(_ctx.fmtDay(_ctx.selectedDay.date)), 1),
                                      _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.dayOfRange', { current: _ctx.selectedDayIndex + 1, total: _ctx.filteredDays.length })), 1)
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "tfa-day-nav",
                                      disabled: !_ctx.canMoveSelectedDay(1),
                                      title: _ctx.$t('components.tachoAnalysis.nextDay'),
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.moveSelectedDay(1)))
                                    }, [...(_cache[46] || (_cache[46] = [
                                      _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)
                                    ]))], 8, _hoisted_106)
                                  ]),
                                  _createElementVNode("div", _hoisted_107, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayTotals, (item) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: item.key,
                                        class: "tfa-chipstat"
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["tfa-sq", 'tfa-sq--' + item.kind])
                                        }, null, 2),
                                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                        _createElementVNode("b", null, _toDisplayString(item.value), 1)
                                      ]))
                                    }), 128)),
                                    (_ctx.selectedDay.day_distance_km != null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_108, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.distance')) + " ", 1),
                                          _createElementVNode("b", null, _toDisplayString(_ctx.group(_ctx.selectedDay.day_distance_km)) + " km", 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _createElementVNode("div", _hoisted_110, [
                                      _createElementVNode("div", _hoisted_111, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.drive')), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.rest')), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.work')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_112, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayBarsZoom(_ctx.selectedDay), (bar, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'b' + i,
                                            class: _normalizeClass(["tfa-bar", ['tfa-bar--' + bar.kind, bar.restKind ? 'tfa-rest--' + bar.restKind : '']]),
                                            style: _normalizeStyle({ left: bar.left, width: bar.width })
                                          }, [
                                            (bar.showLabel)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(bar.label), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", _hoisted_114, [
                                              _createElementVNode("span", _hoisted_115, [
                                                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(bar.tooltip.label), 1)
                                              ]),
                                              (bar.restLabel)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_116, _toDisplayString(bar.restLabel), 1))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", _hoisted_117, _toDisplayString(bar.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_118, _toDisplayString(bar.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_119, _toDisplayString(bar.tooltip.day), 1)
                                            ])
                                          ], 6))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayFerryZoom(_ctx.selectedDay).ranges, (range, i) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: 'fr' + i,
                                            class: "tfa-ferry-range",
                                            style: _normalizeStyle({ left: range.left, width: range.width })
                                          }, [
                                            _cache[49] || (_cache[49] = _createElementVNode("span", { class: "tfa-ferry-range-label" }, "P", -1)),
                                            _createElementVNode("span", _hoisted_120, [
                                              _createElementVNode("span", _hoisted_121, [
                                                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(range.tooltip.label), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_122, _toDisplayString(range.tooltip.detail), 1),
                                              _createElementVNode("span", _hoisted_123, _toDisplayString(range.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_124, _toDisplayString(range.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_125, _toDisplayString(range.tooltip.day), 1)
                                            ])
                                          ], 4))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayFerryZoom(_ctx.selectedDay).markers, (marker, i) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: 'fm' + i,
                                            class: "tfa-ferry-marker",
                                            style: _normalizeStyle({ left: marker.left })
                                          }, [
                                            _cache[51] || (_cache[51] = _createTextVNode(" P ", -1)),
                                            _createElementVNode("span", _hoisted_126, [
                                              _createElementVNode("span", _hoisted_127, [
                                                _cache[50] || (_cache[50] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(marker.tooltip.label), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_128, _toDisplayString(marker.tooltip.detail), 1),
                                              _createElementVNode("span", _hoisted_129, _toDisplayString(marker.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_130, _toDisplayString(marker.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_131, _toDisplayString(marker.tooltip.day), 1)
                                            ])
                                          ], 4))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayPlaceLinesZoom(_ctx.selectedDay), (line, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'l' + i,
                                            class: _normalizeClass(["tfa-place-line", 'tfa-place-line--' + line.kind]),
                                            style: _normalizeStyle({ left: line.left }),
                                            title: line.tooltip.title
                                          }, [
                                            _createElementVNode("span", _hoisted_133, _toDisplayString(line.label), 1),
                                            _createElementVNode("span", _hoisted_134, [
                                              _createElementVNode("span", _hoisted_135, [
                                                _cache[52] || (_cache[52] = _createElementVNode("span", { class: "tfa-place-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(line.tooltip.type), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_136, _toDisplayString(line.tooltip.time), 1),
                                              _createElementVNode("span", _hoisted_137, _toDisplayString(line.tooltip.location), 1),
                                              _createElementVNode("span", _hoisted_138, _toDisplayString(line.tooltip.odo), 1),
                                              _createElementVNode("span", _hoisted_139, _toDisplayString(line.tooltip.day), 1)
                                            ])
                                          ], 14, _hoisted_132))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_140, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dayAxis(_ctx.selectedDay), (t, i) => {
                                        return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(t.label), 1))
                                      }), 128))
                                    ]),
                                    (_ctx.selectedDayPlaces.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayPlaces, (p, i) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: 'pc' + i,
                                              class: _normalizeClass(["tfa-place-chip", 'tfa-place-chip--' + _ctx.placeMarkerKind(p)]),
                                              title: _ctx.placeTooltip(p, _ctx.dowName(_ctx.selectedDay.date) + ' ' + _ctx.selectedDay.date).title
                                            }, [
                                              _createElementVNode("b", null, _toDisplayString(_ctx.placeShortLabel(p)) + " " + _toDisplayString(p._time || _ctx.fmtTime(p.Timestamp)), 1),
                                              _createTextVNode(" " + _toDisplayString(_ctx.placeTypeLabel(p.EntryType)), 1)
                                            ], 10, _hoisted_142))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.canZoomOutDay(_ctx.selectedDay.date))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brushBars(_ctx.selectedDay), (bar, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: 'bb' + i,
                                              class: _normalizeClass(["tfa-brush-bar", ['tfa-brush-bar--' + bar.kind, bar.restKind ? 'tfa-rest--' + bar.restKind : '']]),
                                              style: _normalizeStyle({ left: bar.left, width: bar.width })
                                            }, null, 6))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayFerry(_ctx.selectedDay).ranges, (range, i) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: 'bfr' + i,
                                              class: "tfa-brush-ferry-range",
                                              style: _normalizeStyle({ left: range.left, width: range.width })
                                            }, null, 4))
                                          }), 128)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.miniDayFerry(_ctx.selectedDay).markers, (marker, i) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: 'bfm' + i,
                                              class: "tfa-brush-ferry-marker",
                                              style: _normalizeStyle({ left: marker.left })
                                            }, "P", 4))
                                          }), 128)),
                                          _createElementVNode("div", {
                                            class: "tfa-brush-mask",
                                            style: _normalizeStyle(_ctx.brushMaskLeft(_ctx.selectedDay.date))
                                          }, null, 4),
                                          _createElementVNode("div", {
                                            class: "tfa-brush-mask",
                                            style: _normalizeStyle(_ctx.brushMaskRight(_ctx.selectedDay.date))
                                          }, null, 4),
                                          _createElementVNode("div", {
                                            class: "tfa-brush-sel",
                                            style: _normalizeStyle(_ctx.brushSel(_ctx.selectedDay.date)),
                                            onMousedown: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onBrushDown('pan', _ctx.selectedDay.date, $event)))
                                          }, [
                                            _createElementVNode("span", {
                                              class: "tfa-brush-handle left",
                                              onMousedown: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.onBrushDown('left', _ctx.selectedDay.date, $event)), ["stop"]))
                                            }, null, 32),
                                            _createElementVNode("span", {
                                              class: "tfa-brush-handle right",
                                              onMousedown: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.onBrushDown('right', _ctx.selectedDay.date, $event)), ["stop"]))
                                            }, null, 32)
                                          ], 36)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_144, [
                                    _createElementVNode("div", _hoisted_145, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "tfa-detail-toggle",
                                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.toggleDetail(_ctx.selectedDay.date)))
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(["bi", _ctx.isDetailOpen(_ctx.selectedDay.date) ? 'bi-chevron-down' : 'bi-chevron-right'])
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.detailList')) + " ", 1),
                                        _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.segmentRows(_ctx.selectedDay).length), 1)
                                      ]),
                                      (_ctx.isDetailOpen(_ctx.selectedDay.date))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentRows(_ctx.selectedDay), (s, i) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: 's' + i,
                                                class: "tfa-iv"
                                              }, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["tfa-iv-bar", ['tfa-iv-bar--' + s.kind, s.restKind ? 'tfa-rest--' + s.restKind : '']])
                                                }, null, 2),
                                                _createElementVNode("span", _hoisted_148, _toDisplayString(s.start) + " – " + _toDisplayString(s.stop), 1),
                                                _createElementVNode("span", _hoisted_149, _toDisplayString(s.label), 1),
                                                (s.hasPlace || s.ferry)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_150, [
                                                      (s.hasPlace)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_151, [
                                                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "tfa-place-mark-sm" }, null, -1)),
                                                            _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.placeTag')), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (s.ferry)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_152, [
                                                            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "tfa-ferry-mark-sm" }, "P", -1)),
                                                            _createTextVNode(_toDisplayString(s.ferry), 1)
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.hhmm(s.duration_min)), 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  (_ctx.selectedDayVehicles.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.vehicleInDay')), 1),
                                        _createElementVNode("div", _hoisted_155, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayVehicles, (v, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: 'v' + i,
                                              class: "tfa-day-row"
                                            }, [
                                              _cache[55] || (_cache[55] = _createElementVNode("i", { class: "bi bi-truck" }, null, -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("strong", null, _toDisplayString(v.RegistrationNumber || '—'), 1),
                                                _createElementVNode("small", null, _toDisplayString(_ctx.fmtDateTime(v.FirstUse)) + " → " + _toDisplayString(_ctx.fmtDateTime(v.LastUse)) + " · " + _toDisplayString(_ctx.$t('components.tachoAnalysis.odometer')) + " " + _toDisplayString(_ctx.odometerLabel(v.OdometerBegin)) + " → " + _toDisplayString(_ctx.odometerLabel(v.OdometerEnd)), 1)
                                              ]),
                                              (_ctx.vehicleDistanceLabel(v))
                                                ? (_openBlock(), _createElementBlock("b", _hoisted_156, _toDisplayString(_ctx.vehicleDistanceLabel(v)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.selectedDayPlaces.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesInDay')), 1),
                                        _createElementVNode("div", _hoisted_158, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayPlaces, (p, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: 'p' + i,
                                              class: "tfa-day-row"
                                            }, [
                                              _cache[56] || (_cache[56] = _createElementVNode("i", { class: "bi bi-geo-alt" }, null, -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.placeTypeLabel(p.EntryType)) + " · " + _toDisplayString(p._time || _ctx.fmtTime(p.Timestamp)), 1),
                                                _createElementVNode("small", null, _toDisplayString(_ctx.placeLocation(p)) + " · " + _toDisplayString(_ctx.$t('components.tachoAnalysis.odometer')) + " " + _toDisplayString(p.Odometer != null ? _ctx.group(p.Odometer) + ' km' : '—'), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.selectedDayEvents.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.eventsInDay')), 1),
                                        _createElementVNode("div", _hoisted_160, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedDayEvents, (e, i) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: 'e' + i,
                                              class: "tfa-day-row"
                                            }, [
                                              _cache[57] || (_cache[57] = _createElementVNode("i", { class: "bi bi-exclamation-triangle" }, null, -1)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("strong", null, _toDisplayString(e.title), 1),
                                                _createElementVNode("small", null, _toDisplayString(e.date) + " " + _toDisplayString(e.time) + " · " + _toDisplayString(e.duration || '—'), 1)
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("section", _hoisted_161, [
                                  _createElementVNode("div", _hoisted_162, _toDisplayString(_ctx.$t('components.tachoAnalysis.noDaySelected')), 1)
                                ]))
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.displayGroups, (grp) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: grp.key
                            }, [
                              (grp.week)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_163, [
                                      _createElementVNode("div", _hoisted_164, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.week')) + " " + _toDisplayString(grp.week.week) + " ", 1),
                                        _createElementVNode("span", null, "(" + _toDisplayString(grp.week.from) + " – " + _toDisplayString(grp.week.to) + ")", 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_165, [
                                        _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.$t('components.tachoAnalysis.activities.drive')) + " " + _toDisplayString(_ctx.hhmm(grp.week.totals.drive)), 1),
                                        _createElementVNode("span", _hoisted_167, _toDisplayString(_ctx.$t('components.tachoAnalysis.activities.work')) + " " + _toDisplayString(_ctx.hhmm(grp.week.totals.work)), 1),
                                        _createElementVNode("span", _hoisted_168, _toDisplayString(_ctx.$t('components.tachoAnalysis.driveWork')) + " " + _toDisplayString(_ctx.hhmm(grp.week.totals.drive + grp.week.totals.work)), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_169, [
                                      _createElementVNode("div", _hoisted_170, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.drive')), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.rest')), 1),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.gutter.work')), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_171, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekColumns(grp.week, grp.days), (col) => {
                                          return _withDirectives((_openBlock(), _createElementBlock("div", {
                                            key: 'sep' + col.date,
                                            class: "tfa-day-sep",
                                            style: _normalizeStyle({ left: col.left })
                                          }, null, 4)), [
                                            [_vShow, col.index > 0]
                                          ])
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekColumns(grp.week, grp.days), (col) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'col' + col.date,
                                            class: _normalizeClass(["tfa-day-col", { present: col.present, 'is-hovered': _ctx.hoveredWeekDate === col.date }]),
                                            style: _normalizeStyle({ left: col.left, width: col.width }),
                                            onMouseenter: ($event: any) => (col.present && _ctx.setWeekHover(col.date)),
                                            onMouseleave: ($event: any) => (_ctx.clearWeekHover(col.date)),
                                            onClick: ($event: any) => (col.present && _ctx.goToDay(col.date))
                                          }, [
                                            (col.present)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_173, [
                                                  _createElementVNode("span", _hoisted_174, [
                                                    _cache[58] || (_cache[58] = _createElementVNode("span", { class: "tfa-day-tooltip-dot" }, null, -1)),
                                                    _createElementVNode("b", null, _toDisplayString(col.tooltip.date), 1)
                                                  ]),
                                                  _createElementVNode("span", _hoisted_175, _toDisplayString(col.tooltip.dow), 1),
                                                  _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.$t('components.tachoAnalysis.activities.drive')) + " " + _toDisplayString(col.tooltip.drive), 1),
                                                  _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('components.tachoAnalysis.activities.work')) + " " + _toDisplayString(col.tooltip.work), 1),
                                                  _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.$t('components.tachoAnalysis.driveWork')) + " " + _toDisplayString(col.tooltip.driveWork), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 46, _hoisted_172))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekBars(grp.week, grp.days), (bar, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'wb' + i,
                                            class: _normalizeClass(["tfa-bar", ['tfa-bar--' + bar.kind, bar.restKind ? 'tfa-rest--' + bar.restKind : '']]),
                                            style: _normalizeStyle({ left: bar.left, width: bar.width }),
                                            onMouseenter: ($event: any) => (_ctx.setWeekHover(bar.date)),
                                            onMouseleave: ($event: any) => (_ctx.clearWeekHover(bar.date)),
                                            onClick: _withModifiers(($event: any) => (_ctx.goToDay(bar.date)), ["stop"])
                                          }, [
                                            (bar.showLabel)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_180, _toDisplayString(bar.label), 1))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("span", _hoisted_181, [
                                              _createElementVNode("span", _hoisted_182, [
                                                _cache[59] || (_cache[59] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(bar.tooltip.label), 1)
                                              ]),
                                              (bar.restLabel)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_183, _toDisplayString(bar.restLabel), 1))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("span", _hoisted_184, _toDisplayString(bar.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_185, _toDisplayString(bar.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_186, _toDisplayString(bar.tooltip.day), 1)
                                            ])
                                          ], 46, _hoisted_179))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekFerry(grp.week, grp.days).ranges, (range, i) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: 'wfr' + i,
                                            class: "tfa-ferry-range tfa-ferry-range--week",
                                            style: _normalizeStyle({ left: range.left, width: range.width }),
                                            onMouseenter: ($event: any) => (_ctx.setWeekHover(range.date)),
                                            onMouseleave: ($event: any) => (_ctx.clearWeekHover(range.date)),
                                            onClick: _withModifiers(($event: any) => (_ctx.goToDay(range.date)), ["stop"])
                                          }, [
                                            _cache[61] || (_cache[61] = _createElementVNode("span", { class: "tfa-ferry-range-label" }, "P", -1)),
                                            _createElementVNode("span", _hoisted_188, [
                                              _createElementVNode("span", _hoisted_189, [
                                                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(range.tooltip.label), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_190, _toDisplayString(range.tooltip.detail), 1),
                                              _createElementVNode("span", _hoisted_191, _toDisplayString(range.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_192, _toDisplayString(range.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_193, _toDisplayString(range.tooltip.day), 1)
                                            ])
                                          ], 44, _hoisted_187))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekFerry(grp.week, grp.days).markers, (marker, i) => {
                                          return (_openBlock(), _createElementBlock("span", {
                                            key: 'wfm' + i,
                                            class: "tfa-ferry-marker tfa-ferry-marker--week",
                                            style: _normalizeStyle({ left: marker.left }),
                                            onMouseenter: ($event: any) => (_ctx.setWeekHover(marker.date)),
                                            onMouseleave: ($event: any) => (_ctx.clearWeekHover(marker.date)),
                                            onClick: _withModifiers(($event: any) => (_ctx.goToDay(marker.date)), ["stop"])
                                          }, [
                                            _cache[63] || (_cache[63] = _createTextVNode(" P ", -1)),
                                            _createElementVNode("span", _hoisted_195, [
                                              _createElementVNode("span", _hoisted_196, [
                                                _cache[62] || (_cache[62] = _createElementVNode("span", { class: "tfa-activity-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(marker.tooltip.label), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_197, _toDisplayString(marker.tooltip.detail), 1),
                                              _createElementVNode("span", _hoisted_198, _toDisplayString(marker.tooltip.range), 1),
                                              _createElementVNode("span", _hoisted_199, _toDisplayString(marker.tooltip.duration), 1),
                                              _createElementVNode("span", _hoisted_200, _toDisplayString(marker.tooltip.day), 1)
                                            ])
                                          ], 44, _hoisted_194))
                                        }), 128)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekPlaceLines(grp.week, grp.days), (line, i) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: 'wl' + i,
                                            class: _normalizeClass(["tfa-place-line", 'tfa-place-line--' + line.kind]),
                                            style: _normalizeStyle({ left: line.left }),
                                            title: line.tooltip.title,
                                            onMouseenter: ($event: any) => (_ctx.setWeekHover(line.date)),
                                            onMouseleave: ($event: any) => (_ctx.clearWeekHover(line.date))
                                          }, [
                                            _createElementVNode("span", _hoisted_202, _toDisplayString(line.label), 1),
                                            _createElementVNode("span", _hoisted_203, [
                                              _createElementVNode("span", _hoisted_204, [
                                                _cache[64] || (_cache[64] = _createElementVNode("span", { class: "tfa-place-tooltip-dot" }, null, -1)),
                                                _createElementVNode("b", null, _toDisplayString(line.tooltip.type), 1)
                                              ]),
                                              _createElementVNode("span", _hoisted_205, _toDisplayString(line.tooltip.time), 1),
                                              _createElementVNode("span", _hoisted_206, _toDisplayString(line.tooltip.location), 1),
                                              _createElementVNode("span", _hoisted_207, _toDisplayString(line.tooltip.odo), 1),
                                              _createElementVNode("span", _hoisted_208, _toDisplayString(line.tooltip.day), 1)
                                            ])
                                          ], 46, _hoisted_201))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_209, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekColumns(grp.week, grp.days), (col) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: 'ax' + col.date,
                                          class: _normalizeClass({ absent: !col.present, clickable: col.present }),
                                          onClick: ($event: any) => (col.present && _ctx.goToDay(col.date))
                                        }, _toDisplayString(col.dow) + " " + _toDisplayString(col.dom), 11, _hoisted_210))
                                      }), 128))
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                    ], 64))
              ], 512))
            : (_ctx.activeTab === 'vehicles')
              ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                  _createElementVNode("div", _hoisted_212, [
                    _createElementVNode("div", _hoisted_213, _toDisplayString(_ctx.$t('components.tachoAnalysis.vehiclesTitle')), 1),
                    _createElementVNode("div", _hoisted_214, [
                      _createTextVNode(_toDisplayString(_ctx.vehicleSessions.length) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.sessionsUnit')) + " · " + _toDisplayString((_ctx.result.vehicles || []).length) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.daysUnit')) + " · " + _toDisplayString(_ctx.$t('components.tachoAnalysis.total')) + " ", 1),
                      _createElementVNode("b", null, _toDisplayString(_ctx.group(_ctx.kmSum)) + " km", 1)
                    ])
                  ]),
                  (!_ctx.vehicleSessions.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_215, _toDisplayString(_ctx.$t('components.tachoAnalysis.noVehicles')), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_216, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehicleSessions, (s, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "tfa-veh-card"
                          }, [
                            _createElementVNode("div", _hoisted_217, [
                              _createElementVNode("span", _hoisted_218, [
                                _createElementVNode("span", _hoisted_219, _toDisplayString(s.country || '—'), 1),
                                _createElementVNode("span", _hoisted_220, _toDisplayString(s.vrn), 1)
                              ]),
                              _createElementVNode("span", _hoisted_221, [
                                _createTextVNode(_toDisplayString(s.dateFrom) + " – " + _toDisplayString(s.dateTo) + " · " + _toDisplayString(s.days) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.daysUnit')) + " ", 1),
                                (s.open)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_222, _toDisplayString(_ctx.$t('components.tachoAnalysis.inUse')), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_223, [
                              _createElementVNode("span", _hoisted_224, _toDisplayString(_ctx.$t('components.tachoAnalysis.kmPerDay')), 1),
                              _createElementVNode("div", _hoisted_225, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.bars, (b, j) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: j,
                                    class: "tfa-spark-bar",
                                    style: _normalizeStyle({ height: b.h + '%' })
                                  }, [
                                    _createElementVNode("span", _hoisted_226, [
                                      _createElementVNode("span", _hoisted_227, [
                                        _cache[65] || (_cache[65] = _createElementVNode("span", { class: "tfa-spark-tooltip-dot" }, null, -1)),
                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.dailyMileage')), 1)
                                      ]),
                                      _createElementVNode("span", _hoisted_228, _toDisplayString(b.date), 1),
                                      _createElementVNode("span", _hoisted_229, _toDisplayString(_ctx.group(b.km)) + " km", 1)
                                    ])
                                  ], 4))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_230, [
                              _createElementVNode("span", _hoisted_231, _toDisplayString(_ctx.$t('components.tachoAnalysis.odometer')) + " " + _toDisplayString(s.odoBegin) + " → " + _toDisplayString(s.odoEnd), 1),
                              _createElementVNode("span", _hoisted_232, "Σ " + _toDisplayString(s.totalKm) + " km", 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                ]))
              : (_ctx.activeTab === 'places')
                ? (_openBlock(), _createElementBlock("div", _hoisted_233, [
                    _createElementVNode("div", _hoisted_234, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_235, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesTitle')), 1),
                        _createElementVNode("div", _hoisted_236, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesSub')), 1)
                      ])
                    ]),
                    (!_ctx.placesRows.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_237, _toDisplayString(_ctx.$t('components.tachoAnalysis.noPlaces')), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_238, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesCols.datetime')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesCols.type')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesCols.location')), 1),
                            _createElementVNode("div", _hoisted_239, _toDisplayString(_ctx.$t('components.tachoAnalysis.placesCols.odometer')), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placesRows, (p, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "tfa-grid tfa-grid--places tfa-grid-row"
                            }, [
                              _createElementVNode("div", _hoisted_240, _toDisplayString(p.datetime), 1),
                              _createElementVNode("div", _hoisted_241, [
                                _cache[66] || (_cache[66] = _createElementVNode("span", { class: "tfa-place-mark" }, null, -1)),
                                _createTextVNode(_toDisplayString(p.type), 1)
                              ]),
                              _createElementVNode("div", null, [
                                (p.mapsUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: p.mapsUrl,
                                      target: "_blank",
                                      rel: "noopener"
                                    }, _toDisplayString(p.location), 9, _hoisted_242))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_243, _toDisplayString(p.location), 1))
                              ]),
                              _createElementVNode("div", _hoisted_244, _toDisplayString(p.odo), 1)
                            ]))
                          }), 128))
                        ], 64))
                  ]))
                : (_ctx.activeTab === 'events')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                      _createElementVNode("div", _hoisted_246, [
                        _createElementVNode("div", _hoisted_247, _toDisplayString(_ctx.$t('components.tachoAnalysis.eventsTitle')), 1),
                        _createElementVNode("div", _hoisted_248, _toDisplayString(_ctx.eventsAll.length) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.itemsUnit')), 1)
                      ]),
                      (!_ctx.eventsAll.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_249, _toDisplayString(_ctx.$t('components.tachoAnalysis.noEvents')), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_250, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventsAll, (e, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "tfa-grid tfa-grid--events tfa-grid-row"
                              }, [
                                _createElementVNode("div", _hoisted_251, _toDisplayString(e.date) + " " + _toDisplayString(e.time), 1),
                                _createElementVNode("div", _hoisted_252, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["tfa-dot", 'tfa-dot--' + e.severity])
                                  }, null, 2),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_253, _toDisplayString(e.title), 1),
                                    _createElementVNode("div", _hoisted_254, _toDisplayString(e.detail || '—'), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_255, _toDisplayString(e.duration), 1)
                              ]))
                            }), 128))
                          ]))
                    ]))
                  : (_ctx.activeTab === 'conditions')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                        _createElementVNode("div", _hoisted_257, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_258, _toDisplayString(_ctx.$t('components.tachoAnalysis.conditionsTitle')), 1),
                            _createElementVNode("div", _hoisted_259, _toDisplayString(_ctx.$t('components.tachoAnalysis.conditionsSub')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_260, _toDisplayString(_ctx.conditionsAll.length) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.itemsUnit')), 1)
                        ]),
                        (!_ctx.conditionsAll.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_261, _toDisplayString(_ctx.$t('components.tachoAnalysis.noConditions')), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_262, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionsAll, (condition, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: "tfa-grid tfa-grid--events tfa-grid-row"
                                }, [
                                  _createElementVNode("div", _hoisted_263, _toDisplayString(_ctx.fmtDateTime(condition.Timestamp)), 1),
                                  _createElementVNode("div", _hoisted_264, [
                                    _cache[67] || (_cache[67] = _createElementVNode("span", { class: "tfa-dot tfa-dot--info" }, null, -1)),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", _hoisted_265, _toDisplayString(_ctx.conditionKindLabel(condition.Condition)), 1),
                                      _createElementVNode("div", _hoisted_266, _toDisplayString(_ctx.conditionPhaseLabel(condition.Phase)), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.$t('components.tachoAnalysis.conditionGeneration', { generation: condition.Generation })), 1)
                                ]))
                              }), 128))
                            ]))
                      ]))
                    : (_ctx.activeTab === 'card')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                          _createElementVNode("div", _hoisted_269, _toDisplayString(_ctx.$t('components.tachoAnalysis.cardTitle')), 1),
                          (!_ctx.cardRows.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_270, _toDisplayString(_ctx.$t('components.tachoAnalysis.noCardData')), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_271, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardRows, (row, i) => {
                                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                                    _createElementVNode("div", _hoisted_272, _toDisplayString(row.label), 1),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["tfa-id-value", { mono: row.mono }])
                                    }, _toDisplayString(row.value), 3)
                                  ]))
                                }), 128)),
                                (_ctx.cardStatus)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_273, [
                                      _createElementVNode("div", _hoisted_274, _toDisplayString(_ctx.$t('components.tachoAnalysis.card.status')), 1),
                                      _createElementVNode("div", _hoisted_275, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["tfa-status", 'tfa-status--' + _ctx.cardStatus.kind])
                                        }, [
                                          _cache[68] || (_cache[68] = _createElementVNode("span", { class: "tfa-status-dot" }, null, -1)),
                                          _createTextVNode(_toDisplayString(_ctx.cardStatus.label), 1)
                                        ], 2)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                        ]))
                      : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}